import React from 'react';
import './Verify.css';
import logo from '../logo.png'; // adjust this path as needed

export default function VerifyClean() {
  return (
    <div className="page-wrapper">
      <header className="org-bar">
        <img src={logo} alt="Logo" className="org-bar-logo" />
        <h1 className="org-bar-title">Ministry of Education</h1>
      </header>

      <div className="verify-container">
        <div className="verify-card">
          <div className="verify-spinner">
            <div className="verify-icon-flip">
              <div className="verify-icon-face front">
                <i className="fas fa-shield-alt"></i>
              </div>
              <div className="verify-icon-face back">
                <i className="fas fa-check-circle"></i>
              </div>
            </div>
          </div>

          <div className="verify-header">
            <h2>Profile Verification</h2>
           </div>
           

          <div className="info-box">
            <h3>Why We Need to Verify?</h3>
            <p>This verification will maintain your National ID profile along with your educational profile.</p>
          </div>

          <div className="step">
            <i className="fas fa-check-circle step-icon"></i>
            <div>
              <h4>Identity Confirmation</h4>
              <p>We'll verify your identity using your academic information</p>
            </div>
          </div>

          <div className="step">
            <i className="fas fa-clock step-icon"></i>
            <div>
              <h4>Quick Process</h4>
              <p>The verification usually takes 2–3 minutes</p>
            </div>
          </div>

          <div className="step">
            <i className="fas fa-lock step-icon"></i>
            <div>
              <h4>Secure & Private</h4>
              <p>Your information is encrypted and never shared</p>
            </div>
          </div>

          <div className="data-protection">
            <div className="step">
              <i className="fas fa-shield-alt step-icon"></i>
              <span>Data Protection</span>
            </div>
            <p>Your data is protected under our privacy policy and will only be used along with your educational information.</p>
          </div>

          <div className="cta">
            <button>
              Start Verification <i className="fas fa-arrow-right"></i>
            </button>
            <p>
              By proceeding, you agree to our <span>Terms of Service</span> and <span>Privacy Policy</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
